import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import FootView from '@/pages/goods-new/comps/FootView.vue';
import * as _ from 'underscore';
import { addStatistics } from '../pages/goods-new/require';
let LevelAttrShow = 
// 商详页多规格
class LevelAttrShow extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.level = {};
        this.clickAttrs = [];
        this.discountData = {};
        this.nonExistentLevel = false;
        this.notAllSelect = false;
        this.showAllCollocation = false;
        this.curCollocationId = '';
        this.showVip = false;
        this.getback = false; // 会员价背景色
        this.vipPricebackWidth = 0;
        this.typeMap = {
            presell: '定金预售',
            limit_buy: '限时折扣',
            group: '限时拼团',
            limit_free: '限时免费',
            will_sale: '即将开售',
            will_out: '即将停售',
            is_out: '已下架',
        };
    }
    show() {
        this.isOpen = !this.isOpen;
    }
    //是否有会员价
    get havevipPrice() {
        if (this.level.activityType === 'vipPrice' &&
            this.level.vipPrice !== null) {
            return true;
        }
        else {
            return false;
        }
    }
    get showOriginSalePrice() {
        return this.discountTypeName !== '' && this.discountTypeName !== '买赠活动';
    }
    get limit_buy() {
        return Object.keys(this.skuActivity).length &&
            this.skuActivity[this.level.id] &&
            this.skuActivity[this.level.id].activity_type === 'limit_buy'
            ? this.skuActivity[this.level.id]
            : {};
    }
    get active_buy() {
        return Object.keys(this.skuActivity).length &&
            this.skuActivity[this.level.id]
            ? this.skuActivity[this.level.id]
            : {};
    }
    get gifts() {
        if (this.level.activities &&
            this.level.activities.gift &&
            this.level.activities.gift.giftList &&
            _.isEmpty(_.intersection(['group', 'presell', 'channel'], this.activityNames))) {
            return this.level.activities.gift.giftList || [];
        }
        else {
            return this.level.gifts || [];
        }
    }
    // get salePrice() {
    //   console.log('价格判定嗨嗨嗨', this.level, this.skuActivity)
    //   let price = '¥' + this.level.sale_price
    //   if (
    //     this.level.giftsActivity &&
    //     this.level.giftsActivity.gift &&
    //     !this.limit_buy.id &&
    //     _.isEmpty(
    //       _.intersection(
    //         ['group', 'presell', 'limit_buy', 'channel'],
    //         this.activityNames
    //       )
    //     )
    //   ) {
    //     // 无其他有更改价格活动时 使用赠品活动改价功能
    //     price = '¥' + this.level.giftsActivity.activity_price
    //   }
    //   if (this.level.channel_activity) {
    //     return '¥' + this.level.activityPrice
    //   }
    //   if (this.level.id) {
    //     return price
    //   }
    //   return this.limit_buy.id
    //     ? this.limit_buy.sale_price
    //     : this.spuData.sale_price
    // }
    get salePrice() {
        let price = '¥' + parseFloat(this.level.salePrice);
        if (this.level.giftsActivity &&
            this.level.giftsActivity.gift &&
            !this.active_buy.id &&
            _.isEmpty(_.intersection(['group', 'presell', 'limit_buy', 'channel'], this.activityNames))) {
            // 无其他有更改价格活动时 使用赠品活动改价功能
            price = '¥' + parseFloat(this.level.giftsActivity.activity_price);
        }
        // if (this.level.channel_activity) {
        //   return '¥' + this.level.activityPrice
        // }
        if (this.level.id) {
            return price;
        }
        return this.active_buy.id
            ? parseFloat(this.active_buy.sale_price)
            : parseFloat(this.spuData.sale_price);
    }
    get profitRange() {
        let profitArr = this.skuData.filter(v => v.profit);
        if (!profitArr.length) {
            return false;
        }
        profitArr = profitArr.map(x => x.profit);
        let max = Reflect.apply(Math.max, null, profitArr);
        let min = Reflect.apply(Math.min, null, profitArr);
        return min === max ? `${min}` : `${min}-${max}`;
    }
    get discountTypeName() {
        let limitBuyType = this.discountData.tag === '限时报名' ? '限时报名' : '限时折扣';
        let type = this.discountData.activity_type;
        let { planPublishTime, planUnpublishTime } = this.level;
        let plan_publish_time = planPublishTime;
        let plan_unpublish_time = planUnpublishTime;
        // 即将开售
        if (plan_publish_time && !plan_unpublish_time) {
            // 当前时间和开售时间对比7天
            let day7 = new Date(plan_publish_time.replace(/-/gi, '/')).getTime() -
                new Date().getTime() -
                7 * 24 * 60 * 60 * 1000;
            // 7天内
            if (day7 < 0) {
                type = 'will_sale';
            }
        }
        // 即将停售
        if (!plan_publish_time && plan_unpublish_time) {
            // 当前时间和开售时间对比7天
            let t1 = new Date(plan_unpublish_time.replace(/-/gi, '/')).getTime();
            let t2 = new Date().getTime();
            // 7天内
            if (t1 - t2 < 7 * 24 * 60 * 60 * 1000) {
                type = 'will_out';
            }
        }
        let lastname = (type === 'limit_buy' ? limitBuyType : this.typeMap[type]) || '';
        if (lastname === '') {
            let disObj = this.level.activities
                ? this.level.activities.distribution || {}
                : {};
            lastname = Object.keys(disObj).length > 0 ? '分销活动' : '';
        }
        if (lastname === '') {
            if (!this.havevipPrice &&
                this.level.activities &&
                this.level.activities.gift &&
                Object.keys(this.level.activities.gift).length !== 0) {
                lastname = '买赠活动';
            }
        }
        return lastname;
    }
    // get scaleRange() {
    //   let scaleArr = this.skuData.filter(v => v.scale)
    //   if (!scaleArr.length) {
    //     return false
    //   }
    //   scaleArr = scaleArr.map(x => (+x.scale * 100).toFixed(0))
    //   let max = Reflect.apply(Math.max, null, scaleArr)
    //   let min = Reflect.apply(Math.min, null, scaleArr)
    //   return min === max ? `${min}` : `${min}-${max}`
    // }
    get giftsFilter() {
        return this.gifts.filter(i => i.isShoWGift);
    }
    get popupVisible() {
        return this.visible;
    }
    get collocations() {
        let collocations = this.collocationList.filter(el => el.type === 'stable');
        return this.showAllCollocation
            ? collocations.slice(0)
            : collocations.slice(0, 2);
    }
    get curColloInfo() {
        if (!this.curCollocationId) {
            return {};
        }
        else {
            return this.collocations.find(el => el.id === this.curCollocationId) || {};
        }
    }
    get showMoreCollocations() {
        return (this.collocationList.filter(el => el.type !== 'stable').length > 2 &&
            !this.showAllCollocation);
    }
    get showGoldDiscountValue() {
        let end = this.goldData.discount_end;
        let start = this.goldData.discount_start;
        if (!end)
            return false;
        let endTime = +new Date(end.replace(/-/g, '/'));
        let startTime = +new Date(start.replace(/-/g, '/'));
        let nowTime = +new Date();
        if (endTime <= nowTime ||
            nowTime < startTime ||
            !this.goldData.discounted_value) {
            // 已超过倒计时时间,不展示
            return false;
        }
        return true;
    }
    created() {
        console.log('这是当前的商品信息', this.curLevel, this.attrData);
        this.level = this.curLevel;
        this.discountData = this.skuActivity[this.level['id']] || {};
        let _clickAttrs = {};
        Object.keys(this.attrData).forEach(v => {
            _clickAttrs[v] = '';
        });
        if (this.curLevel.id) {
            this.level._num = 1;
            let clickedIds = [];
            let attrMap = null;
            for (let item in this.attrData) {
                let idsItems = _.indexBy(this.attrData[item], 'attrValueId');
                attrMap = { ...attrMap, ...idsItems };
            }
            console.log(this.attrData, attrMap);
            Object.keys(attrMap).forEach(key => {
                if (attrMap[key].skuId === this.curLevel.id) {
                    clickedIds = key.split('-');
                }
            });
            let attrsArray = Object.keys(this.attrData).reduce((sum, cur) => {
                return [...sum, ...this.attrData[cur]];
            }, []);
            attrsArray.forEach(v => {
                if (clickedIds.indexOf(v.attrValueId + '') !== -1) {
                    _clickAttrs[v.attrName] = v.attrValueId;
                }
            });
        }
        this.clickAttrs = _clickAttrs;
        console.log(this.clickAttrs);
    }
    async levelHandle(key, item) {
        // 埋点 点击规格
        // debugger
        addStatistics({
            event: 'Click_Specification_H5',
            p1: this.$route.query.spuId + '_' + item.sku_id || '',
            p2: item.id,
            p3: this.goodsStatus,
        });
        // console.log(this.attrData, item.attrValueId)
        // this.clickAttrs[key] !== item.attrValueId
        //   ? (this.clickAttrs[key] = item.attrValueId)
        //   : (this.clickAttrs[key] = '')
        if (this.clickAttrs[key] !== item.attrValueId) {
            this.clickAttrs[key] = item.attrValueId;
        }
        this.curCollocationId = '';
        let allClicked = true;
        let ids = [];
        Object.keys(this.clickAttrs).forEach(k => {
            ids.push(this.clickAttrs[k]);
            if (!this.clickAttrs[k]) {
                allClicked = false;
            }
        });
        if (!allClicked) {
            this.level = { _num: 1 };
            this.notAllSelect = true;
            this.nonExistentLevel = false;
            this.changeLevel(this.level);
            return;
        }
        this.notAllSelect = false;
        console.log(ids);
        ids = ids.sort();
        let idsTemp = ids.join('-');
        let AllattrIds = [];
        let Allattr = [];
        for (item in this.attrData) {
            let idsItems = _.indexBy(this.attrData[item], 'attrValueId');
            Allattr = { ...idsItems };
            let arr = Object.keys(idsItems);
            AllattrIds = [...arr];
        }
        console.log(Allattr, ids.join('-'));
        if (!AllattrIds.map(r => r
            .split('-')
            .sort()
            .join('-')).includes(idsTemp)) {
            // 如果该组合不存在，不操作
            this.level = { _num: 1 };
            this.nonExistentLevel = true;
            this.changeLevel({ noLevel: true });
            return;
        }
        this.nonExistentLevel = false;
        // this.level = this.skuData.find(v => v.id === this.attrMap[ids.join('-')].id)
        this.level = this.skuData.find(v => v.id === Allattr[ids.join('-')].skuId);
        this.level._num = 1;
        let skuId = this.level ? this.level.id : '';
        this.discountData = this.skuActivity[skuId] || {};
        this.changeLevel(this.level);
    }
    hide(text, type) {
        let r;
        if (text === 'collocation') {
            r = { type: 'toCollocation', cid: this.curCollocationId };
        }
        else {
            r = this.level.id ? this.level : false;
        }
        this.close(r);
    }
    changeNum(type) {
        if (this.notAllSelect || (!this.level.id && !this.nonExistentLevel)) {
            return this.$Toast('至少选择1件商品');
        }
        else if (type === 'add') {
            this.level._num >= 200
                ? this.$Toast('不能再加啦，商品最多添加200件')
                : this.level._num++;
        }
        else if (type === 'sub') {
            this.level._num <= 1
                ? this.$Toast('不能再减了，商品至少购买一件')
                : this.level._num--;
        }
        this.$forceUpdate();
    }
    getIsSellout(item) {
        let skuInfo = this.skuData.find(el => el.id === item.skuId);
        if (!skuInfo)
            return true;
        return skuInfo.virtualInventoryQty <= 0;
    }
    async clickCollocation(item) {
        let acticityInfo = this.collocationList.find(el => el.id === item.id) || {};
        this.uploadEvent.sendRecord('Click_GoodsDetail_Popup_Collocation', '', {
            GoodsName: this.spuData.title,
            SkuID: this.skuData.reduce((t, c, i) => {
                t += i === 0 ? c.id : `_${c.id}`;
                return t;
            }, ''),
            ActivityName: acticityInfo.title,
            ActivityID: acticityInfo.id,
        }, [
            ['p1', 'GoodsName'],
            ['p2', 'SkuID'],
            ['p3', 'ActivityName'],
            ['p4', 'ActivityID'],
        ]);
        for (let key in this.clickAttrs) {
            this.clickAttrs[key] = '';
        }
        this.level = { _num: 1 };
        this.changeLevel({ noLevel: true });
        this.curCollocationId = item.id;
    }
    closeModal() {
        this.close();
    }
    showDistributionShareOK() {
        this.showDistributionShare();
    }
};
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "visible", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "type", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "spuData", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "skuData", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "attrData", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "attrName", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "curLevel", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "buttonName", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "changeLevel", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "skuActivity", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "isCrm", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "activityNames", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "goldShow", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "goldData", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "goldDiscount", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "goodsStatus", void 0);
tslib_1.__decorate([
    Prop()
], LevelAttrShow.prototype, "notFooterType", void 0);
tslib_1.__decorate([
    Prop({ default: [] })
], LevelAttrShow.prototype, "collocationList", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], LevelAttrShow.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], LevelAttrShow.prototype, "showDistributionShare", void 0);
LevelAttrShow = tslib_1.__decorate([
    Component({
        components: {
            FootView,
        },
        filters: {
            filterVipprice: function (price = '') {
                return parseFloat(price);
            },
        },
    })
    // 商详页多规格
], LevelAttrShow);
export default LevelAttrShow;
